import { landingMotionInView } from "@/utils/landingMotion";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import cardimg from "/image/funnel/globehand.png";

/** Gradient ring + lime center dot — same treatment as FeatureBadge in FunnelPage (no checkmark). */
function GradientRadioBullet({ className = "" }: { className?: string }) {
    return (
        <div
            className={`mt-[0.35em] shrink-0 p-[1px] rounded-full bg-gradient-to-r from-[#1CCDE6] to-[#DBD633] h-max ${className}`.trim()}
            aria-hidden
        >
            <div className="flex h-3 w-3 items-center justify-center rounded-full bg-black md:h-3.5 md:w-3.5">
                <span className="h-[5px] w-[5px] rounded-full bg-[#DBD633] md:h-1.5 md:w-1.5" />
            </div>
        </div>
    );
}

function GradientImageFrame({
    src,
    alt,
    className = "",
    imgClassName = "w-full h-auto object-cover",
}: {
    src: string;
    alt: string;
    className?: string;
    imgClassName?: string;
}) {
    return (
        <div className={`border-gradient-urfx-ring [--urfx-border-r:20px] md:[--urfx-border-r:50px] ${className}`.trim()}>
            <div className="border-gradient-urfx-ring-inner">
                <img src={src} alt={`${alt} logo`} className={imgClassName} />
            </div>
        </div>
    );
}
const CHOOSE_FEATURES = [
    "Instant Funded Accounts",
    "Transparent Trading Rules",
    "No Challenge Phase",
    "Fast Payouts Cycles",
    "AI-Powered Risk Manager",
    "Scalable Accoutns",
] as const;

export default function ChooseCard() {
    const { t } = useTranslation();
    return (
        <div className="grid grid-cols-1 items-center gap-8 md:grid-cols-2 md:gap-12 lg:gap-20 xl:px-0 px-4 max-w-7xl mx-auto pb-20">
            <motion.div className="order-1 md:order-2" {...landingMotionInView}>
                <div className="flex justify-start ">
                    {/* subtitle The lading prop firm */}
                    <motion.div
                        className="w-fit h-auto p-[1.5px] rounded-[20px] bg-gradient-to-r from-[#1CCDE6] to-[#DBD633] flex justify-center items-center"
                        {...landingMotionInView}
                    >
                        <div className="w-fit px-3 bg-black rounded-[20px] p-1 flex items-center justify-center">
                            <span
                                className="bg-clip-text text-[12px] sm:text-[13px] xl:text-base text-transparent font-nexa font-bold uppercase"
                                style={{
                                    backgroundImage:
                                        "linear-gradient(to left, #D7D536, #20CDE2)",
                                    display: "inline-block",
                                }}
                            >
                                {("Choose us")}
                            </span>
                        </div>
                    </motion.div>
                </div>
                <motion.h2
                    className="font-nexa font-normal pt-3 md:pt-0 text-[32px]  md:text-[56px] leading-tight tracking-tight"
                    {...landingMotionInView}
                >
                    
                    <span className="[box-decoration-break:clone] px-2 bg-gradient-to-l italic from-[#D6E242] via-[#9DDF78] to-60% to-[#79DDC7] bg-clip-text  text-transparent">
                        {t("Why Traders Choose URFX")}
                    </span>{" "}
                    {t("Over Everyone Else")}
                </motion.h2>
                <motion.div
                    className="text-lg md:text-xl font-nexa order-2 md:order-1 !font-normal  text-white pt-2 "
                    {...landingMotionInView}
                >
                    <p>{t("Built for serious traders who want real capital, real payouts, and zero unnecessary barriers.")}</p>
                    <ul
                        className="mt-6 grid grid-cols-1 gap-x-10 gap-y-3 sm:grid-cols-2 font-nexa text-white"
                        role="list"
                    >
                        {CHOOSE_FEATURES.map((key) => (
                            <li key={key} className="flex gap-3">
                                <GradientRadioBullet />
                                <span className="text-base leading-snug md:text-lg">{t(key)}</span>
                            </li>
                        ))}
                    </ul>
                </motion.div>
                <motion.div
                        className="flex justify-start gap-3 w-auto mt-5"
                        {...landingMotionInView}
                    >
                        <a href="/pricing" className="btn-gradient-left w-auto text-lg font-bold py-2 px-3 md:px-6 rounded-[10px]">
                        Start Challenge
                        </a>
                    </motion.div>
            </motion.div>
            <motion.div className="order-1 md:order-2" {...landingMotionInView}>
                <GradientImageFrame
                    src={cardimg}
                    alt="trading dashboard"
                    imgClassName="aspect-[4/3] select-none w-full rounded-xl md:rounded-[50px] object-cover md:aspect-[5/4] md:min-h-[380px] md:max-h-[480px]"
                />
            </motion.div>
        </div>
    )
}